
import { PlayCircle, FileText, Eye } from 'lucide-react';
import { getVideoEmbedUrl } from '@/lib/utils';
import { formatViewCount } from '@/lib/youtube';

interface MediaCardProps {
  id: string;
  title: string;
  image: string;
  type: 'video' | 'article';
  date: string;
  link: string;
  featured?: boolean;
  videoId?: string;
  viewCount?: string;
}

const MediaCard = ({
  id,
  title,
  image,
  type,
  date,
  link,
  featured = false,
  videoId,
  viewCount,
}: MediaCardProps) => {
  // Determine the proper link to use
  const videoLink = videoId ? `https://www.youtube.com/watch?v=${videoId}` : link;
  
  return (
    <a
      href={videoLink}
      target="_blank"
      rel="noopener noreferrer"
      className="group block overflow-hidden rounded-lg bg-adv-charcoal border border-adv-darkGray/30 transition-all duration-300 hover:shadow-xl h-full"
    >
      <div className="relative overflow-hidden aspect-video">
        <img
          src={image}
          alt={title}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-adv-dark to-transparent opacity-70"></div>
        
        {featured && (
          <div className="absolute top-3 left-3 bg-adv-orange text-white text-xs font-medium px-2 py-0.5 rounded flex items-center">
            Featured
          </div>
        )}
        
        {type === 'video' ? (
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="bg-adv-orange/80 rounded-full p-3 transform transition-all duration-300 group-hover:scale-110 group-hover:bg-adv-orange">
              <PlayCircle size={24} className="text-white" />
            </div>
          </div>
        ) : (
          <div className="absolute top-3 right-3">
            <div className="bg-adv-darkGray/80 backdrop-blur-sm rounded-full p-2">
              <FileText size={18} className="text-white" />
            </div>
          </div>
        )}
        
        {viewCount && (
          <div className="absolute bottom-3 right-3 bg-adv-dark/80 backdrop-blur-sm rounded-md px-2 py-1 flex items-center text-white text-xs">
            <Eye size={12} className="mr-1" /> {formatViewCount(viewCount)}
          </div>
        )}
      </div>
      <div className="p-4">
        <div className="flex items-center justify-between text-xs text-adv-lightGray mb-2">
          <span>{date}</span>
        </div>
        <h3 className="font-bold text-white transition-colors group-hover:text-adv-orange text-lg line-clamp-2">
          {title}
        </h3>
      </div>
    </a>
  );
};

export default MediaCard;
